<template>
<div class="chapter">
<div class="inner_page">
<div>
<div class="chapter" id="toc">
<p class="ctfm">Contents</p>
<p class="tocfm"><a href="#/eerkaiulani0009#ack" id="rack"><em>Acknowledgments</em></a></p>
<p class="tocfm"><a href="#/eerkaiulani0010#lan" id="rlan"><em>A Word About the Hawaiian Language</em></a></p>
<p class="tocfm"><a href="#/eerkaiulani0011#pro" id="rpro"><em>Prologue</em></a></p>
<p class="toc"><a href="#/eerkaiulani0014#ch01" id="rch01">1. Two Worlds Collide</a></p>
<p class="toc"><a href="#/eerkaiulani0016#ch02" id="rch02">2. At Home with the Cleghorns</a></p>
<p class="toc"><a href="#/eerkaiulani0018#ch03" id="rch03">3. So Hard to Say Good-bye</a></p>
<p class="toc"><a href="#/eerkaiulani0020#ch04" id="rch04">4. An Unexpected Friend</a></p>
<p class="toc"><a href="#/eerkaiulani0022#ch05" id="rch05">5. The New World</a></p>
<p class="toc"><a href="#/eerkaiulani0024#ch06" id="rch06">6. Hawai‘i’s New Queen</a></p>
<p class="toc"><a href="#/eerkaiulani0026#ch07" id="rch07">7. On the World Stage</a></p>
<p class="toc"><a href="#/eerkaiulani0028#ch08" id="rch08">8. The Princess and the President</a></p>
<p class="toc"><a href="#/eerkaiulani0030#ch09" id="rch09">9. A Nation in the Balance</a></p>
<p class="toc"><a href="#/eerkaiulani0032#ch10" id="rch10">10. Exile</a></p>
<p class="toc"><a href="#/eerkaiulani0034#ch11" id="rch11">11. Home at Last</a></p>
<p class="toc"><a href="#/eerkaiulani0036#ch12" id="rch12">12. Gone with the Tradewinds</a></p>
<p class="toc"><a href="#/eerkaiulani0038#ch13" id="rch13">13. A Final Purpose</a></p>
<p class="tocbm"><a href="#/eerkaiulani0039#bib" id="rbib"><em>My Sources for This Book</em></a></p>
<p class="tocbm"><a href="#/eerkaiulani0040#ref" id="rref"><em>Suggestions for Further Reading</em></a></p>
<p class="tocbm"><a href="#/eerkaiulani0041#img" id="rimg"><em>Photo Credits</em></a></p>
<p class="tocbm"><a href="#/eerkaiulani0042#ind" id="rind"><em>Index</em></a></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eer-kaiulani-0008.vue?d5edd004